import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import { QuantityChipRevokable } from '../shared.styled';
const getRevokeChipColor = (availableQuantity, blockedQuantity) => {
    if (availableQuantity === 0) {
        if (blockedQuantity === 0)
            return 'success';
        else
            return 'warning';
    }
    return 'yellow';
};
const ReceiptedQuantityChip = ({ availableQuantity, receiptedQuantity, blockedQuantity, onDelete, onDoubleClick }) => {
    const handleDoubleClick = (event) => {
        // Prevents *row* double click event (same action as Enter key press).
        event.stopPropagation();
    };
    return (_jsx(QuantityChipRevokable, { size: "medium", variant: "outlined", color: getRevokeChipColor(availableQuantity, blockedQuantity), label: receiptedQuantity, title: `${t('cancel.receipt.label')} (-)`, tabIndex: -1, onDelete: onDelete, onDoubleClick: onDoubleClick ?? handleDoubleClick }));
};
export { ReceiptedQuantityChip };
